import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('PrincipalControlSet', PrincipalControlSetData);

    /* @ngInject */
    function PrincipalControlSetData() {
        PrincipalControlSet.prototype = {
            build: build
        };

        function PrincipalControlSet(principalControlSetData) {
            this.build(principalControlSetData);
        }

        return PrincipalControlSet;

        /////////////////////

        function build(principalControlSetData) {
            this.key = principalControlSetData.key || null;
            this.dictionaryKey = principalControlSetData.dictionaryKey || null;
            this.name = principalControlSetData.name || null;
            this.desc = principalControlSetData.desc || false;
            this.standard = principalControlSetData.standard || false;
            this.selected = principalControlSetData.selected || false;
            this.filtreDO = principalControlSetData.filtreDO || false;
        }
    }
})();